module.exports = __webpack_public_path__ + "img/number_3.7ec4bf78.png";